<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`dynamicComponent-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// layouts
import FooterOne from '~/components/theme8/base/footer/FooterOne.vue';
import HeaderOne from '~/components/theme8/base/header/HeaderOne.vue';

// library components
import FormContainer from '~/components/library/FormContainer.vue';

// theme8 components
import Test from '~/components/theme8/components/Test.vue';
import ScrollAnimationTexts from '~/components/theme8/components/ScrollAnimationTexts.vue';
import OurValuations from '~/components/theme8/components/OurValuations.vue';
import OurTeam from '~/components/theme8/components/OurTeam.vue';
import Properties from '~/components/theme8/properties/Properties.vue';
import LatestPodcast from '~/components/theme8/components/LatestPodcast.vue';
import ManageCard from '~/components/library/ManageCard.vue';
import RegisterEntry from '~/components/theme8/register/RegisterEntry.vue';
import Register from '~/components/theme8/register/Register.vue';
import Podcasts from '~/components/theme8/components/Podcasts.vue';
import StoryBox from '~/components/theme8/components/StoryBox.vue';
import TakeAction from '~/components/theme8/components/TakeAction.vue';
import OurValues from '~/components/theme8/components/OurValues.vue';
import ContentBox from '~/components/theme8/components/ContentBox.vue';
import GoogleReview from '~/components/theme8/components/GoogleReview.vue';
import SmallBox from '~/components/theme8/components/SmallBox.vue';
import HeroSection from '~/components/theme8/components/HeroSection.vue';
import PropertyListItem from '~/components/theme8/properties/PropertyListItem.vue';
import ContactCard from '~/components/theme8/components/ContactCard.vue';
import VideoTestimonials from '~/components/theme8/components/VideoTestimonials.vue';
import StorySlider from '~/components/theme8/components/StorySlider.vue';
import OurGuide from '~/components/theme8/components/OurGuide.vue';
import InfoBox from '~/components/theme8/components/InfoBox.vue';
import IntroSection from '~/components/theme8/components/IntroSection.vue';
import WhyBox from '~/components/theme8/components/WhyBox.vue';
import BlogsBox from '~/components/theme8/components/BlogsBox.vue';
import AgentCard from '~/components/theme8/components/AgentCard.vue';
import FeaturedProperties from '~/components/theme8/components/FeaturedProperties.vue';
import CountSection from '~/components/theme8/components/CountSection.vue';
import WhySection from '~/components/theme8/components/WhySection.vue';
import BranchesLocation from '~/components/theme8/components/BranchesLocation.vue';
import ContactUs from '~/components/theme8/components/ContactUs.vue';
import InfoGallery from '~/components/theme8/components/InfoGallery.vue';
import NotFoundPage from '~/components/theme8/components/NotFoundPage.vue';

// common
import PropertiesEntry from '~/components/common/properties/PropertiesEntry.vue';
import Separator from '~/components/library/Separator.vue';
import RedirectTo from '~/components/common/RedirectTo.vue';

// blogs components
import {
  LibraryPropertiesOnTheFlySearchBox,
  Theme8BlogsPage,
  Theme8BlogsOurBlog,
  Theme8PropertiesLatestProperties,
  Theme8PropertiesPropertyDetail,
  Theme8BlogsBlogDetail,
} from '#components';
import UpdateProfileEntry from '~/components/library/heads_up_alerts/UpdateProfileEntry.vue';
import LoginBox from '~/components/library/LoginBox.vue';

export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },
  },

  components: {
    HeaderOne,
    FooterOne,
    FormContainer,
    Properties,
    ContentBox,
    GoogleReview,
    TakeAction,
    OurValues,
    Register,
    ManageCard,
    HeroSection,
    RegisterEntry,
    PropertiesEntry,
    Separator,
    SmallBox,
    RedirectTo,
    Podcasts,
    LatestPodcast,
    OnTheFlyPropertySearchBox: LibraryPropertiesOnTheFlySearchBox,
    PropertyDetail: Theme8PropertiesPropertyDetail,
    LatestProperties: Theme8PropertiesLatestProperties,
    OurBlog: Theme8BlogsOurBlog,
    BlogsPage: Theme8BlogsPage,
    BlogDetail: Theme8BlogsBlogDetail,
    UpdateProfileEntry,
    LoginBox,
    Test,
    ScrollAnimationTexts,
    OurValuations,
    OurTeam,
    StoryBox,
    ContactUs,
    ContactCard,
    VideoTestimonials,
    InfoGallery,
    StorySlider,
    OurGuide,
    NotFoundPage,
    InfoBox,
    BlogsBox,
    IntroSection,
    WhyBox,
    AgentCard,
    FeaturedProperties,
    CountSection,
    WhySection,
    BranchesLocation,
  },
});
</script>
